import { Grid } from "@mui/material";
import React/* , { useEffect, useState } */ from "react";
import { useTranslation } from "react-i18next";
import InicioCard from "../../../components/InicioCard";
import AAFFIcon from "../../../images/aaff.png"

function Inicio() {
  const { t } = useTranslation('common');
  return (<>
    <div style={{
      textAlign: 'center',
      fontSize: 28,
      color: "#303248",
      fontWeight: 'bold',
      marginTop: 90
    }}>{t('home.welcome')}</div>
    <div style={{
      textAlign: 'center',
      fontSize: 22,
      color: "#303248",
      marginTop: 10,
      marginBottom: 70
    }}>{t('home.whatToDo')}</div>
    <Grid container direction="row" justifyContent="center" alignItems="center" spacing={5}>
      <Grid item><InicioCard icono={AAFFIcon} texto={t('home.manageAaff')} ruta="/aaff" /></Grid>
    </Grid>
  </>);
}

export default Inicio;
